import { render, staticRenderFns } from "./deanHeaderItemDropdown.vue?vue&type=template&id=ec844e62&scoped=true"
import script from "./deanHeaderItemDropdown.vue?vue&type=script&lang=ts"
export * from "./deanHeaderItemDropdown.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderItemDropdown.vue?vue&type=style&index=0&id=ec844e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec844e62",
  null
  
)

export default component.exports